// See https://redux.js.org/usage/deriving-data-selectors

export const route = (state: any) => state.router.location.pathname;
